import { DETECTION_EXPLORER_NOW_GRACE_MINUTES, DETECTION_EXPLORER_WINDOW_MINUTES } from './config'

// The allowed [cutoff, now] window for the from/to filters. `cutoff` is the furthest back `from`
// may point (now − 48h, matching the backend grace). `now` is the `to` ceiling, held a couple of
// minutes in the past so a client clock running ahead of the server can't push `to` into the future
// (the backend rejects that with no grace). Shared by the Filters time-window UI and the store's
// "apply image request" action so both clamp identically.
export type WindowBounds = { now: Date; cutoff: Date }

export const computeWindowBounds = (): WindowBounds => {
    const realNow = Date.now()
    // `to` ceiling sits slightly in the past to absorb client/server clock skew.
    const now = new Date(realNow - DETECTION_EXPLORER_NOW_GRACE_MINUTES * 60 * 1000)
    // `from` floor measured from the real now so the full 48h window stays available.
    const cutoff = new Date(realNow - DETECTION_EXPLORER_WINDOW_MINUTES * 60 * 1000)
    return { now, cutoff }
}

export const clampToWindow = (date: Date, { now, cutoff }: WindowBounds): Date => {
    if (date < cutoff) return cutoff
    if (date > now) return now
    return date
}
